(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('FixCardsService', FixCardsService);

  FixCardsService.$inject = ['$resource'];

  function FixCardsService ($resource) {
    return $resource(apiUrl + '/fix-cards/:id', { id: '@id' }, {
      callCommand: { url: apiUrl + '/fix-cards/call-command', method: 'POST', params: {}, isArray: false }
    });
  }
})();
